import { render, staticRenderFns } from "./customerPopup.vue?vue&type=template&id=347a5e78&scoped=true&"
import script from "./customerPopup.vue?vue&type=script&lang=js&"
export * from "./customerPopup.vue?vue&type=script&lang=js&"
import style0 from "./customerPopup.vue?vue&type=style&index=0&id=347a5e78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347a5e78",
  null
  
)

export default component.exports